import React, { useState, useEffect } from "react";
import { SmallCard } from "../Cards/SmallCard";
import {
  get,
  post,
  put,
  deleteRequestV2,
} from "../../api/usersModule/httpClient";
import { useDebounce } from "../../hooks/useDebounce";
import { CDBModal } from "cdbreact";
import { ModalReceptions } from "../Modals/ModalReceptions";
import { LargeCard } from "../../Components/Cards/LargeCard";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { format } from "mathjs";

const usersheaders = [
  "Lote",
  "Código SAP",
  "Descripción",
  "Código Proveedor",
  "Proveedor",
  "Unidades recibidas ",
  "Unidades defectuosas",
  "% Defectuosas",
  "% Aprobadas",
  "Descripción",
  "Fecha de modificación",
  "Usuario",
  "/reception",
];

const defaultFormData = {
  LotNumber: "",
  CodeSap: "",
  UnitsReception: 0,
  UnitsDefective: 0,
  ReceptionsDescription: "",
};

export const CrudReceptions = ({
  userName,
  permissions,
  project,
  codeSap,
  nit,
  setChange,
  change,
}) => {
  const [data, setData] = useState([]);
  const [state, setState] = useState({ modal6: false });
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [pressedButton, setPressedButton] = useState("");
  const [action, setAction] = useState("");
  const [skus, setSkus] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [initialRender, setInitialRender] = useState(true);
  const [changePage, setChangePage] = useState(false);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  const getData = async (search, statusPage) => {
    setLoading(true);
    try {
      let response;
      if (codeSap != "" && codeSap != null && codeSap != undefined) {
        response = await get(
          `/receptions?page=${statusPage}&search=${search}&CodeSap=${codeSap}&Nit=${nit}&limit=${itemsPerPage}`
        );
      } else {
        response = await get(
          `/receptions?page=${statusPage}&search=${search}&Nit=${project}&limit=${itemsPerPage}`
        );
      }
      if (response.answer) {
        setTotalItems(response.pagination.totalItems);
      } else {
        setTotalItems(0);
      }
      setData(response.items);
    } catch (error) {
      console.error("Error fetching data:", error);
      swal(
        "Error",
        "Error al obtener los datos. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const getReception = async (numLote) => {
    try {
      const response = await get(
        `/receptions?LotNumber=${numLote.split("/*-/")[0]}&Nit=${
          numLote.split("/*-/")[1]
        }`
      );
      setFormData(response.items[0]);
      toggle(6)();
    } catch (error) {
      console.error("Error fetching reception:", error);
      swal(
        "Error",
        "Error al obtener la recepción. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
    }
  };

  const getSku = async () => {
    try {
      const response = await get(`/skus?Nit=${project}&Lista=True`);
      if (response && response.items) {
        setSkus(response.items);
      } else {
        console.error("Error fetching SKUs: Response format incorrect");
        swal(
          "Error",
          "Error al obtener los SKUS. Por favor, inténtelo de nuevo más tarde.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching SKUs:", error);
      swal(
        "Error",
        "Error al obtener los SKUS. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
    }
  };

  const closeModal = () => {
    setState({ ...state, modal6: false });
  };

  const toggle = (nr) => () => {
    let modalNumber = "modal" + nr;
    setState({ ...state, [modalNumber]: !state[modalNumber] });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const convertDataToArray = () => {
    try {
      if (!data || data.length === 0) {
        return [];
      }

      return data.map((item) => {
        const totalUnidades = parseFloat(item.UnitsReception).toFixed(2);
        const unidadesDefectuosas = parseFloat(item.UnitsDefective).toFixed(2);

        const porcentajeBuenas = parseFloat(
          ((totalUnidades - unidadesDefectuosas) / totalUnidades) * 100
        ).toFixed(2);
        const porcentajeDefectuosas = parseFloat(
          (unidadesDefectuosas / totalUnidades) * 100
        ).toFixed(2);

        return [
          item.LotNumber.toUpperCase(),
          item.CodeSap.toUpperCase(),
          item.SkuDescription,
          item.Nit.toUpperCase(),
          item.ProjectName.toUpperCase(),
          totalUnidades,
          unidadesDefectuosas,
          porcentajeDefectuosas + "%",
          porcentajeBuenas + "%",
          item.ReceptionsDescription.toUpperCase(),
          item.ModificationDate,
          item.User.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" "),
        ];
      });
    } catch (error) {
      console.error("Error converting data to array:", error);
      return [];
    }
  };

  const handleSubmit = () => {
    const requiredFields = ["LotNumber", "CodeSap"];

    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      swal("Error", "Por favor, rellene todos los campos", "error");
      setLoading(false);
      return false;
    }

    return true;
  };

  const saveData = async () => {
    Swal.fire({
      title: `${action === "create" ? "Creando" : "Actualizando"} Recepción`,
      text: "Por favor, espere...",
      icon: "info",
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    let {
      CodeSap,
      LotNumber,
      UnitsReception,
      UnitsDefective,
      ReceptionsDescription,
      Nit,
    } = formData;
    const User = userName || "Admin";

    if (CodeSap.includes("/*-/")) {
      Nit = CodeSap.split("/*-/")[0];
      CodeSap = CodeSap.split("/*-/")[1];
    }

    try {
      const response = await (action === "create" ? post : put)("/receptions", {
        LotNumber: LotNumber.toUpperCase(),
        CodeSap: CodeSap.toUpperCase(),
        Nit: Nit.toUpperCase(),
        UnitsReception: parseFloat(UnitsReception) || 0.0,
        UnitsDefective: parseFloat(UnitsDefective) || 0.0,
        ReceptionsDescription: ReceptionsDescription.toUpperCase(),
        User: User.split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" "),
      });
      Swal.close();
      if (
        (response && response.response && response.response.status !== 200) ||
        !response.answer
      ) {
        swal(
          "Error",
          `No se pudo ${
            action === "create" ? "crear" : "actualizar"
          } la recepción. Por favor, revise la información (Puede deberse, a que ya se tiene un CodeSap o un LOTE ya registrado).`,
          "error"
        );
      } else if (response.answer) {
        toggle(6)();
        swal(
          `Recepción ${action === "create" ? "creada" : "actualizada"}`,
          `La recepción se ${
            action === "create" ? "creó" : "actualizó"
          } correctamente.`,
          "success"
        );
      }
      setChange(change + 1);
      getData("", 1);
    } catch (error) {
      Swal.close();
      console.error(
        `Error al ${
          action === "create" ? "crear" : "actualizar"
        } la recepción:`,
        error
      );
      swal(
        "Error",
        `Error al ${
          action === "create" ? "crear" : "actualizar"
        } la recepción. Por favor, inténtelo de nuevo más tarde.`,
        "error"
      );
    }
  };

  const deleteSku = async () => {
    const User = userName || "Admin";

    const body = JSON.stringify({
      CodeSap: formData.CodeSap,
      LotNumber: formData.LotNumber,
      Nit: formData.Nit,
      UnitsReception: formData.UnitsReception,
      UnitsDefective: formData.UnitsDefective,
      User: User,
    });

    const confirmDelete = await Swal.fire({
      title: "Confirmar Eliminación de la Recepción",
      text: "Esta acción eliminará de manera permanente la Recepción seleccionada, así como cualquier dato relacionado. ¿Está seguro de que desea proceder?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#146284",
      cancelButtonColor: "#EF4444",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (confirmDelete.isConfirmed) {
      try {
        Swal.fire({
          title: "Eliminando Recepción",
          text: "Por favor, espere...",
          icon: "info",
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        await deleteRequestV2("receptions", body, true);

        Swal.close();

        toggle(6)();
        getData("", 1);
      } catch (error) {
        console.error("Error deleting SKU:", error);
        swal(
          "Error",
          "Error al eliminar la recepción. Por favor, inténtelo de nuevo más tarde.",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    if (!changePage) {
      getData(debouncedSearch, page);
    } else {
      setChangePage(false);
    }
  }, [page, initialRender]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [itemsPerPage]);

  useEffect(() => {
    switch (pressedButton.split(",")[0]) {
      case "create":
        if (permissions["Crear"]) {
          getSku();
          setAction("create");
          setFormData(defaultFormData);
          toggle(6)();
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para crear una recepción",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "edit":
        if (permissions["Editar"]) {
          getSku();
          setAction("edit");
          getReception(pressedButton.split(",")[1]);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para editar una recepción",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "delete":
        if (permissions["Eliminar"]) {
          deleteSku(pressedButton.split(",")[1]);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para borrar una recepción",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "refresh":
        getData("", page);
        break;
      case "closeModal":
        toggle(6)();
        break;
      case "submitModal":
        const success = handleSubmit();
        if (success) {
          saveData();
        }
        break;
      default:
        break;
    }
    setPressedButton("");
  }, [pressedButton]);

  return (
    <>
      <LargeCard
        name="Recepción"
        headers={usersheaders}
        loading={loading}
        data={convertDataToArray()}
        totalItems={totalItems}
        customTable={false}
        setPage={setPage}
        page={page}
        setChangePage={setChangePage}
        setPressedButton={setPressedButton}
        setSearch={setSearch}
        cState={true}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        stateReception={true}
      />
      <CDBModal isOpen={state.modal6} toggle={toggle(6)}>
        <ModalReceptions
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          closeModal={closeModal}
          handleChange={handleChange}
          skus={skus}
        />
      </CDBModal>
    </>
  );
};
